// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"gKWNtg3AANGw","close":"XS6PEJ8_gxyk","title":"_1O3lkyvC1hz0","footer":"_3wA_sincMObk","cancel":"_1pSz7nS7j84-"};